var $ = jQuery;

$(window).load(function(){

  const $Panels = $('.st-panel, .st-anim-trigger, .st-case-study-panel');
  const $parrallaxScroller = $('.st-parallax-container');
  $('body').addClass('st-anim-load');
  var scrollCount = 0;

  if ($parrallaxScroller.length) {
    const $pageWrap = $('#page');

    if ($Panels.length) {
      $pageWrap.on('scroll', function () {
        const $body = $('body');
        const $anim = $('.st-anim-trigger');
        var animScroll = $pageWrap.scrollTop() + $(window).height() / 2;
        var bodyClasses = $body.attr('class').split(/\s+/);
        var animsInView = new Array();

        $anim.each(function () {
          var $this = $(this);

          if ($this.offset().top <= animScroll && $this.offset().top + $this.height()  < animScroll - $(window).height()) {
            animsInView.push('-anim-' + $(this).data('anim'));
          }
        });

        for (var i = 0; i < animsInView.length; i++) {
          if (!$body.hasClass(animsInView[i])) {
            removeAnims(bodyClasses, animsInView);
            $body.addClass(animsInView[i]);
          }
        }

        function removeAnims(bodyClasses, animsInView) {
          for (var i = 0; i < bodyClasses.length; i++) {
            if (jQuery.inArray(bodyClasses[i], animsInView) >= 0) {// do nothin
            } else if (bodyClasses[i].startsWith('-anim')) {
              $body.removeClass(bodyClasses[i]);
            }
          }
        }

        scrollCount++;
      }).scroll();
    }
  }
  else if ($Panels.length) {
    $(window).on('scroll', function () {
      const $window = $(window);
      const $body = $('body');
      const $panel = $('.st-panel');
      const $anim = $('.st-anim-trigger');
      var panelScroll = $window.scrollTop() + $window.height() / 3;
      var animScroll = $window.scrollTop() + $window.height() / 2;
      var bodyClasses = $body.attr('class').split(/\s+/);
      var animsInView = new Array();
      $panel.each(function () {
        var $this = $(this);

        if ($this.position().top <= panelScroll && $this.position().top + $this.height() > panelScroll) {
          $body.removeClass(function (index, css) {
            return (css.match(/(^|\s)-bg-\S+/g) || []).join(' ');
          });
          $body.addClass('-bg-' + $(this).data('color'));
        }
      });
      $anim.each(function () {
        var $this = $(this);
        var windowPosTrigger = $(this).data('windowPosPercent') ? $window.scrollTop() + $window.height() * ($(this).data('windowPosPercent') / 100) : animScroll;

        if ($this.offset().top <= windowPosTrigger && $this.offset().top + $this.height() > windowPosTrigger) {
          animsInView.push('-anim-' + $(this).data('anim'));
        }
      });

      for (var i = 0; i < animsInView.length; i++) {
        if (!$body.hasClass(animsInView[i])) {
          removeAnims(bodyClasses, animsInView);
          $body.addClass(animsInView[i]);
        }
      }

      function removeAnims(bodyClasses, animsInView) {
        for (var i = 0; i < bodyClasses.length; i++) {
          if (jQuery.inArray(bodyClasses[i], animsInView) >= 0) {// do nothin
          } else if (bodyClasses[i].startsWith('-anim')) {
            $body.removeClass(bodyClasses[i]);
          }
        }
      }

      scrollCount++;
    }).scroll();
  }

});